/* 
 * 本地缓存 及 HTTP客户端与服务器请求会话 扩展
 * 缓存默认有效时长120分钟，会话默认有效时长为30分钟
 */
'use strict'

import 'es6-promise/auto';
/**存储KEY前缀 */
var prefix = { session: 'VUE.Session.ZQZC.', cache: "VUE.Cache.ZQZC." };
/**
 * 本地存储
 * @param {string} type 存储类型（cahe,session）
 * @param {string} key 数据KEY键
 * @param {json} value 数据内容
 * @param {int} time 有效时长 (value=null,time=-1)
 */
var cacheHelper = function (type, key, value, time) {  
  var cacheKey = "";
  var objStorage = undefined;  
  var djson = { d: value, t: 0, m: 0 };
  var vnull = (value === null || value === undefined);

  if (type=='cache') { 
    cacheKey = prefix.cache + key;
    objStorage = window.localStorage; 
  };
  if (type=='session') { 
    cacheKey = prefix.session + key;
    objStorage = window.sessionStorage; 
  };

  // 判断Storage是否为空
  if (objStorage == undefined) { return djson.d; }

  // 移除缓存
  if (vnull && time === -1) {
    objStorage.removeItem(cacheKey);
    return djson.d;
  }

  // 判断缓存是否为存在
  var storeData = objStorage.getItem(cacheKey);
  if (storeData != null && storeData != undefined) {
    djson = JSON.parse(storeData);
    if (djson && djson.t > 0) {
      if (!vnull) { djson.d = value; }
      // 判断缓存是否已过期
      if (vnull && djson.t - new Date().getTime() < 0) {
        djson.d = undefined;
      }
    }
  }

  // 缓存value不为空 写入
  if (djson.d != null && djson.d != undefined) {
    var mtime = (djson.m || time);
    var times = (new Date().getTime() + 60 * 999 * mtime);
    objStorage.setItem(cacheKey, JSON.stringify({ d: djson.d, t: times, m: mtime }));
  }

  return djson.d;
};

/** 会话请求 ****************************************************************************************/
var session = function(){};
/**
 * 清空请求会话
 */
session.clear = function() { window.sessionStorage.clear(); };
/**
 * 移除一个有效的会话
 * @param {string} key 会话主键
 */
session.remove = function(key) { return cacheHelper('session', key, undefined, -1); };
/**
 * 获取一个会话的值
 * @param {string} key 会话主键
 */
session.get = function(key) { return cacheHelper('session', key, undefined, 0); };
/**
 * 读取或修改一个会话
 * @param {string} key 会话主键
 * @param {object} value 会话值
 * @param {number} time 会话有效时长
 */
session.set = function(key, value, time) { if(time==null){time=30;}if(time==undefined){time=30;}return cacheHelper('session', key, value, time); };

/** 本地缓存 ****************************************************************************************/
var cache = function(){};
/**
 * 清空本地缓存
 */
cache.clear = function() { window.localStorage.clear(); };
/**
 * 移除一个缓存
 * @param {string} key 缓存主键
 */
cache.remove = function(key) { return cacheHelper('cache', key, undefined, -1); };
/**
 * 获取一个缓存的值
 * @param {string} key 缓存主键
 */
cache.get = function(key) { return cacheHelper('cache', key, undefined, 0); };
/**
 * 读取或修改一个缓存
 * @param {string} key 缓存主键
 * @param {object} value 缓存值
 * @param {number} time 缓存有效时长
 */
cache.set = function(key, value, time) { if(time==null){time=120;}if(time==undefined){time=120;} return cacheHelper('cache', key, value, time); };

export default { session: session, cache: cache};


// WEBPACK FOOTER //
// ./src/assets/js/storage.js